import React, { useState /*, useContext*/ } from 'react';
// import ApplicationContext from '../components/ApplicationContext';

function SignupPage({ setData }) {
    // const data = useContext(ApplicationContext);

    const [formData, setFormData] = useState({
		username: '',
		password: '',
		email: ''
	});

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// Handle sign-up logic here
		// console.log(formData);
	};
    
    // const handleSignup = () => {
    //     // Implement your signup logic here
    //     setData((prevData) => ({
    //         ...prevData,
    //         currentPage: 'login', // Redirect to login after signup
    //     }));
    // };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <h1>Sign Up</h1>
                <input type="text" name="username" placeholder="Username" onChange={handleChange} />
                <input type="email" name="email" placeholder="Email" onChange={handleChange} />
                <input type="password" name="password" placeholder="Password" onChange={handleChange} />
                <button type="submit">Sign Up</button>
                {/* <button onClick={handleSignup}>Sign Up</button> */}
                {/* <button onClick={() => setData((prev) => ({ ...prev, currentPage: 'login' }))}>Go to Login</button> */}
            </form>
        </>
    );
}

export default SignupPage;
